import React from "react";
import { useLocation } from "react-router-dom";

function useHttp() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export default useHttp;
